import reduxStore from 'lib/reduxStore'
import { resetAll } from 'redux/features/auth/authSlice'
import routesConfig, { gotoLoginAppAuthorize } from 'lib/routesConfig'
import { clearAllBccStorage } from 'lib/oauth2/bccOAuth2Utils'
import { getCurrentEntryPath } from 'lib/loginAppUtils'

export function reauthenticate() {
  reduxStore.dispatch(resetAll())
  routesConfig.BCC_LOGIN.goto(undefined, true)
}

export function reauthenticateLoginApp() {
  const accountHint = reduxStore.getState().auth.accessTokenObject?.bccAccountId
  const entryPath = getCurrentEntryPath()

  // Do NOT reset the store here. gotoLoginAppAuthorize() is a full-page navigation, so the store dies with
  // the page anyway, and resetting it early makes concurrent 401/422 responses (intercepted before the
  // navigation commits) classify as a SOAP session and overwrite this redirect with /bcc-login.
  clearAllBccStorage()
  gotoLoginAppAuthorize({ accountHint, entryPath })
}
